export default function SVGRouter(props: any) {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M14.5 32L7 49H57L49.5 32H14.5Z" stroke="#757575" strokeWidth="2" strokeLinejoin="round" />
            <path d="M15 7V32" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M49 7V32" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M32 7V32" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 50V57H57V50" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
